export const emptyGuid = '00000000-0000-0000-0000-000000000000';
